// extracted by mini-css-extract-plugin
export var skipAnimation = "_m-0";